export const GET_ACTIVITIES = "GET_ACTIVITIES";
export const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS";
export const GET_ACTIVITIES_FAILURE = "GET_ACTIVITIES_FAILURE";
export const GET_ACTIVITIES_RESET = "GET_ACTIVITIES_RESET";

export const ADD_ACTIVITY_NOTE = "ADD_ACTIVITY_NOTE";
export const ADD_ACTIVITY_NOTE_SUCCESS = "ADD_ACTIVITY_NOTE_SUCCESS";
export const ADD_ACTIVITY_NOTE_FAILURE = "ADD_ACTIVITY_NOTE_FAILURE";
export const ADD_ACTIVITY_NOTE_RESET = "ADD_ACTIVITY_NOTE_RESET";
